/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormProxiesNotify
 */
export interface FormProxiesNotify {
    /**
     * 
     * @type {string}
     * @memberof FormProxiesNotify
     */
    emailBody?: string;
}

export function FormProxiesNotifyFromJSON(json: any): FormProxiesNotify {
    return FormProxiesNotifyFromJSONTyped(json, false);
}

export function FormProxiesNotifyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormProxiesNotify {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailBody': !exists(json, 'email_body') ? undefined : json['email_body'],
    };
}

export function FormProxiesNotifyToJSON(value?: FormProxiesNotify | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email_body': value.emailBody,
    };
}


